/** API enums for F&B restaurant flows */

export const FnBRestaurantSourceType = {
	MANUAL: "MANUAL",
	SEVENROOMS: "SEVENROOMS",
} as const;

export type FnBRestaurantSourceType =
	(typeof FnBRestaurantSourceType)[keyof typeof FnBRestaurantSourceType];

export const FnBVenueStatus = {
	DRAFT: "DRAFT",
	PUBLISHED: "PUBLISHED",
	INACTIVE: "INACTIVE",
} as const;

export type FnBVenueStatus =
	(typeof FnBVenueStatus)[keyof typeof FnBVenueStatus];

export const FnBPropertyType = {
	RESTAURANT: "RESTAURANT",
	CABANA: "CABANA",
	RESTAURANT_CABANA: "RESTAURANT_CABANA",
} as const;

export type FnBPropertyType =
	(typeof FnBPropertyType)[keyof typeof FnBPropertyType];

export type FnBApplicableFor = FnBPropertyType;

export const FnBMenuType = {
	WEB_LINK: "WEB_LINK",
	PDF: "PDF",
} as const;

export type FnBMenuType = (typeof FnBMenuType)[keyof typeof FnBMenuType];

/** GET /fnb-restaurants `sortBy` query enum */
export const FnBRestaurantSortBy = {
	DEFAULT: "DEFAULT",
	NAME: "NAME",
	PROPERTY_NAME: "PROPERTY_NAME",
	SOURCE: "SOURCE",
	STATUS: "STATUS",
	UPDATED_AT: "UPDATED_AT",
} as const;

export type FnBRestaurantSortBy =
	(typeof FnBRestaurantSortBy)[keyof typeof FnBRestaurantSortBy];

export interface FnBRestaurantFaqPayload {
	applicable: FnBApplicableFor;
	question: string;
	answer: string;
}

export interface FnBRestaurantSeatingPayload {
	applicable: FnBApplicableFor;
	seatingId: string;
}

export interface FnBRestaurantUpsertPayload {
	propertyType?: FnBPropertyType;
	name: string;
	propertyId: string;
	phoneNo?: string;
	status: FnBVenueStatus;
	address?: string;
	googleLocation?: string;
	description?: string;
	bannerImage?: string;
	media?: string[];
	cabanaBannerImage?: string;
	cabanaMedia?: string[];
	cuisineTags?: string[];
	faqs?: FnBRestaurantFaqPayload[];
	seatingType?: FnBRestaurantSeatingPayload[];
	menuType?: FnBMenuType;
	menuWebUrl?: string;
}
